import axios from "axios";
import authHeader from "../auth-header";
import { API_URL } from "../../constants/api";
import { BodyPhotoShareDto } from "../../types/types";

class BodyPhotosShareService {

  /**
   * GET shares for body photo
   */
  getBodyPhotoShares(photoId: string) {
    return axios.get<BodyPhotoShareDto[]>(
      `${API_URL}/body_photo_share/${photoId}`,
      { headers: authHeader() }
    );
  }

  /**
   * POST share body photo to users
   */
  shareBodyPhoto(photoId: string, shareToUsers: number[]) {
    return axios.post<void>(
      `${API_URL}/body_photo_share/${photoId}`,
      shareToUsers,
      { headers: authHeader() }
    );
  }
}

export default new BodyPhotosShareService();
